module.exports = __webpack_public_path__ + "static/acceleration-abaaf46e9bde959aeab3798b4d9f7cfb.png";